export default __webpack_public_path__ + "assets/exame-component.4bad9bb2.svg";